import createByIdReducer from '../../../reducers/byId';
import { getArticleSuccess } from '../../actions/getArticle';
import { getArticlesSuccess } from '../../actions/getArticles';
/**
 * Holds all articles that have been loaded during the application's session. Follows the `byId` reducer pattern, please see those docs for more information about what state it holds.
 *
 * It has the following action map:
 *
 * - add: [getArticleSuccess, getArticlesSuccess]
 * - remove: []
 *
 * Note that this byId reducer uses the `slug` field as the key for each item
 *
 * ```js
 * import { ghost } from '@minerva-analytics/pantheon';
 * const { byId } = ghost.reducers;
 *
 * // To select data from this reducer in a component
 * import { useSelector } from 'react-redux';
 *
 * const Test = () => {
 *   // Note that you may need to change this depending on where the ghost
 *   // model is integrated in your store
 *   const byId = useSelector((state) => state.ghost.byId);
 *
 *   return <div>Test</div>
 * };
 * ```
 */

var byId = createByIdReducer({
  actionMap: {
    add: [getArticleSuccess, getArticlesSuccess],
    remove: []
  },
  options: {
    key: 'slug'
  }
});
export default byId;